import { Controller } from 'stimulus';
const TomSelect = require('../../lib/tom_select');

export default class extends Controller {
  connect() {
    if (this.tomSelect) return;

    this.tomSelect = new TomSelect(this.element, {
      valueField: 'id',
      labelField: 'text',
      searchField: 'text',
      placeholder: this.element.dataset.placeholder || '',
      load: (query, callback) => {
        const url = new URL(this.element.dataset.url, window.location.origin);
        url.searchParams.set('term', query);
        fetch(url)
          .then(response => response.json())
          .then(json => { callback(json); })
          .catch(() => { callback(); });
      },
    });
  }

  disconnect() {
    if (this.tomSelect) {
      this.tomSelect.destroy();
      this.tomSelect = null;
    }
  }
}
